const script = document.querySelector('script[data-upgrade-map]');
const mapUrl = script?.dataset.upgradeMap;
const root = window.Shopify?.routes?.root || '/';
const url = path => `${root}${path}`.replace(/\/\//g, '/');
const json = async (path, init) => {
  const response = await fetch(url(path), {credentials:'same-origin',cache:'no-store',...init});
  const body = await response.json().catch(()=>null);
  if (!response.ok) throw Object.assign(new Error(body?.description || 'Cart request failed'),{body});
  return body;
};
const post = (path, body) => json(path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
const normalized = value => Object.entries(value || {}).sort(([a],[b])=>a.localeCompare(b));
const same = (a,b) => JSON.stringify(normalized(a)) === JSON.stringify(normalized(b));
const identity = item => JSON.stringify([item.variant_id,normalized(item.properties),item.selling_plan_allocation?.selling_plan?.id || null]);
const fingerprint = cart => JSON.stringify(cart.items.map(item=>[item.key,item.quantity]));
const currency = (amount,code) => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:code || 'USD'}).format(amount/100);
let manifest;
let busy=false;
const reviewError=message=>Object.assign(new Error(message),{needsReview:true});

function mappedProduct(id) { return manifest?.products.find(product=>product.id===Number(id)); }
function mappedVariant(product,id) { return product.variants.find(variant=>variant.id===Number(id)); }
function sourceValues(variant) { return Object.fromEntries(variant.options.map(option=>[option.name,option.value])); }

function refreshButtons() {
  for (const button of document.querySelectorAll('[data-native-cart-upgrade]')) {
    const product=mappedProduct(button.dataset.productId);
    const row=button.closest('[data-key]');
    const strip=button.closest('.native-cart-upgrade-strip');
    const selected=product?.variants.find(variant=>Number(variant.id)===Number(button.dataset.variantId));
    // The rendered row key is authoritative; a fresh Ajax lookup confirms the variant on open.
    if (!product || !row) {button.hidden=true;if(strip)strip.hidden=true;continue;}
    if(button.hidden)button.hidden=false;
    if(strip?.hidden)strip.hidden=false;
    let label='Edit options';
    if (selected) {
      const values=sourceValues(selected);
      const atStartingOptions=product.upgradeOptions.every(option=>values[option.name]===option.values[0]);
      if (atStartingOptions) label='Explore upgrades';
    }
    if(button.textContent!==label)button.textContent=label;
    const heading=strip?.querySelector('.native-cart-upgrade-strip__copy strong');
    const copy=label==='Explore upgrades'?'Upgrade this item':'Edit this item';
    if(heading && heading.textContent!==copy)heading.textContent=copy;
  }
}

function editorHost(button) {
  const component=button.closest('cart-items-component');
  const drawer=component?.closest('cart-drawer-component');
  return {component,drawer,parent:drawer?.querySelector('.cart-drawer__inner') || component?.parentElement};
}

function make(tag, text, className) {
  const node=document.createElement(tag);
  if (text!==undefined) node.textContent=text;
  if (className) node.className=className;
  return node;
}

async function openEditor(button) {
  if (busy) return;
  if (window.__ocNativeCartCheckoutPending) throw Error('Checkout is in progress. Please wait.');
  const product=mappedProduct(button.dataset.productId);
  if (!product) return;
  const current=await json('cart.js');
  const source=current.items.find(item=>item.key===button.dataset.lineKey);
  if (!source || Number(source.product_id)!==product.id || source.selling_plan_allocation || source.has_components) throw Error('This item changed. Reload the cart before editing.');
  const mapped=mappedVariant(product,source.variant_id);
  if (!mapped) throw Error('This configuration is not in the approved upgrade map.');
  const live=await json(`products/${encodeURIComponent(product.handle)}.js`);
  const liveById=new Map(live.variants.map(variant=>[Number(variant.id),variant]));
  const {component,drawer,parent}=editorHost(button);
  if (!component || !parent) throw Error('Cart editor could not be opened.');
  const pane=make('section',undefined,'native-cart-editor');
  const pageOverlay=drawer?null:make('div',undefined,'native-cart-editor-overlay');
  if(pageOverlay){pane.classList.add('native-cart-editor--page');pane.setAttribute('role','dialog');pane.setAttribute('aria-modal','true');}
  pane.setAttribute('aria-label',`Edit ${source.product_title} options`);
  pane.tabIndex=-1;
  const heading=make('h2','Edit your options');
  const closeButton=make('button','×','native-cart-editor__close');
  closeButton.type='button';closeButton.setAttribute('aria-label','Cancel editing options');
  pane.append(heading,closeButton);
  const scrollArea=make('div',undefined,'native-cart-editor__scroll');
  const footer=make('div',undefined,'native-cart-editor__footer');
  const productCard=make('div',undefined,'native-cart-editor__product');
  if(source.image){const image=document.createElement('img');image.src=source.image;image.alt='';productCard.append(image);}
  const productText=make('div');
  const selectedSummary=product.upgradeOptions.map(option=>sourceValues(mapped)[option.name]).filter(Boolean);
  productText.append(make('strong',source.product_title),make('p',[...selectedSummary,`Quantity ${source.quantity}`].join(' · ')));
  productCard.append(productText);scrollArea.append(productCard);
  const selectors=new Map();
  const original=sourceValues(mapped);
  for(const [index,option] of product.upgradeOptions.entries()){
    const group=make('fieldset',undefined,'native-cart-editor__group');
    group.append(make('legend',`${index+1}. ${option.name}`));
    const radios=[];
    for(const value of option.values){
      const label=make('label',undefined,'native-cart-editor__choice');
      const radio=document.createElement('input');radio.type='radio';radio.name=`upgrade-${index}`;radio.value=value;radio.checked=value===original[option.name];
      const name=make('span',value);
      const delta=make('span','', 'native-cart-editor__choice-price');
      label.append(radio,name,delta);group.append(label);
      radios.push({radio,delta,value});
    }
    selectors.set(option.name,radios);
    scrollArea.append(group);
  }
  const price=make('p','', 'native-cart-editor__price');
  price.setAttribute('aria-live','polite');
  const subtotal=make('p','', 'native-cart-editor__subtotal');
  const error=make('p','', 'native-cart-editor__error');
  error.setAttribute('role','alert');
  error.hidden=true;
  const actions=make('div',undefined,'native-cart-editor__actions');
  const update=make('button','Update item','button');
  update.type='button';
  const cancel=make('button','Cancel','button button--secondary');
  cancel.type='button';
  actions.append(update,cancel);
  footer.append(price,subtotal,error,actions);
  const cue=make('button',undefined,'native-cart-scroll-cue native-cart-editor__cue');
  cue.type='button';cue.setAttribute('aria-label','Scroll for more options');
  cue.append(document.createTextNode('Scroll for more '),make('span','⌄'));
  cue.lastElementChild.setAttribute('aria-hidden','true');
  pane.append(scrollArea,cue,footer);
  const updateCue=()=>{cue.hidden=scrollArea.scrollHeight<=scrollArea.clientHeight+8||scrollArea.scrollTop+scrollArea.clientHeight>=scrollArea.scrollHeight-8;};
  scrollArea.addEventListener('scroll',updateCue,{passive:true});
  const cueResize=new ResizeObserver(updateCue);
  cueResize.observe(scrollArea);
  cueResize.observe(pane);
  cue.addEventListener('click',()=>scrollArea.scrollBy({top:Math.max(180,scrollArea.clientHeight*.65),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
  const oldDisplay=component.style.display;
  if(pageOverlay){pageOverlay.append(pane);document.body.append(pageOverlay);}
  else{component.style.display='none';parent.append(pane);}
  requestAnimationFrame(updateCue);
  window.__ocNativeCartEditorOpen=true;
  document.dispatchEvent(new Event('native-cart:editor-state'));
  pane.focus();
  function close(){cueResize.disconnect();document.removeEventListener('keydown',onEscape,true);drawer?.removeEventListener('dialog:close',close);if(pageOverlay)pageOverlay.remove();else{pane.remove();component.style.display=oldDisplay;}window.__ocNativeCartEditorOpen=false;document.dispatchEvent(new Event('native-cart:editor-state'));button.focus();}
  drawer?.addEventListener('dialog:close',close,{once:true});
  let requiresReview=false;
  const cancelClick=event=>{event.preventDefault();event.stopPropagation();if(requiresReview)window.location.reload();else close();};
  cancel.addEventListener('click',cancelClick);
  closeButton.addEventListener('click',cancelClick);
  const onEscape=event=>{if(event.key==='Escape'){event.preventDefault();event.stopImmediatePropagation();if(requiresReview)window.location.reload();else close();}};
  document.addEventListener('keydown',onEscape,true);
  function target(overrides={}){
    const chosen={...original};
    for(const [name,radios] of selectors) chosen[name]=radios.find(item=>item.radio.checked)?.value;
    Object.assign(chosen,overrides);
    const candidate=product.variants.find(variant=>variant.options.every(option=>chosen[option.name]===option.value));
    return candidate && liveById.get(candidate.id);
  }
  function updatePreview(){
    const variant=target();
    update.disabled=!variant?.available || variant.id===source.variant_id;
    for(const [name,radios] of selectors){
      const base=target({[name]:radios.find(choice=>choice.radio.checked)?.value});
      for(const choice of radios){
        const optionVariant=target({[name]:choice.value});
        choice.radio.disabled=!optionVariant?.available;
        choice.delta.textContent=optionVariant?.available && base ? (optionVariant.price===base.price?'':`${optionVariant.price>base.price?'+':'−'}${currency(Math.abs(optionVariant.price-base.price),current.currency)}`) : 'Unavailable';
      }
    }
    const change=(variant?.price-(liveById.get(source.variant_id)?.price || source.original_price))*source.quantity;
    price.textContent=variant?.available
      ? `Updated item total: ${currency(variant.price*source.quantity,current.currency)}`
      : 'This combination is unavailable.';
    subtotal.textContent=variant?.available && change
      ? `${change<0?'Savings':'Increase'}: ${currency(Math.abs(change),current.currency)}. Final cart subtotal updates after selection.`
      : '';
  }
  for(const radios of selectors.values())for(const choice of radios)choice.radio.addEventListener('change',updatePreview);
  updatePreview();
  update.addEventListener('click',async()=>{
    if(busy)return;
    busy=true; update.disabled=true; cancel.disabled=true;error.hidden=true;
    try {
      const chosen=target();
      if(!chosen?.available)throw Error('This combination is no longer available.');
      await swapLine(source,chosen,product,current);
      sessionStorage.setItem('oc-native-cart-reopen',drawer?'yes':'no');
      window.location.reload();
    } catch(e) {
      error.textContent=e.message || 'Cart update needs review. Reload your cart before trying again.';
      error.hidden=false;
      cancel.disabled=false;
      requiresReview=Boolean(e.needsReview);
      cancel.textContent=requiresReview?'Review cart':'Cancel';
      if(requiresReview)update.disabled=true;
      else updatePreview();
    } finally {busy=false;}
  });
}

async function swapLine(source,target,product,opened) {
  const before=await json('cart.js');
  if(fingerprint(before)!==fingerprint(opened))throw Error('Your cart changed. Review it before updating options.');
  const exact=before.items.find(item=>item.key===source.key);
  if(!exact || exact.quantity!==source.quantity || !same(exact.properties,source.properties))throw Error('This cart line changed. Review it before updating options.');
  const live=await json(`products/${encodeURIComponent(product.handle)}.js`);
  const valid=live.variants.find(variant=>Number(variant.id)===Number(target.id));
  if(!valid?.available || valid.price!==target.price)throw Error('Price or availability changed. Review the options again.');
  const matches=item=>item.variant_id===target.id && same(item.properties,source.properties) && !item.selling_plan_allocation;
  const sourceMatches=item=>item.variant_id===source.variant_id && same(item.properties,source.properties) && !item.selling_plan_allocation;
  const sourceBefore=before.items.filter(sourceMatches);
  if(sourceBefore.length!==1 || sourceBefore[0].key!==source.key)throw Error('This configuration has multiple cart lines. Review them before editing options.');
  const others=value=>value.items.filter(item=>!matches(item)&&!sourceMatches(item)).map(item=>[identity(item),item.quantity]).sort((a,b)=>a[0].localeCompare(b[0]));
  const previous=before.items.filter(matches).reduce((n,item)=>n+item.quantity,0);
  try {await post('cart/add.js',{id:target.id,quantity:source.quantity,properties:source.properties || {}});}
  catch { /* A failed request may still have applied. Inspect below. */ }
  const afterAdd=await json('cart.js').catch(()=>{throw reviewError('The cart could not be confirmed after adding. Reload and review all lines before trying again.');});
  const targetLines=afterAdd.items.filter(matches);
  const targetQty=targetLines.reduce((n,item)=>n+item.quantity,0);
  const sourceAfterLines=afterAdd.items.filter(sourceMatches);
  const sourceAfter=sourceAfterLines.length===1 ? sourceAfterLines[0] : null;
  const unrelatedUnchanged=JSON.stringify(others(before))===JSON.stringify(others(afterAdd));
  if(targetQty!==previous+source.quantity || !sourceAfter || sourceAfter.quantity!==source.quantity || targetLines.length!==1 || !unrelatedUnchanged){
    throw reviewError('The add could not be attributed safely. Review all cart lines before trying again.');
  }
  try {await post('cart/change.js',{id:sourceAfter.key,quantity:0});}
  catch { /* The mutation may have succeeded. Inspect actual cart below. */ }
  const final=await json('cart.js').catch(()=>{throw reviewError('The cart could not be confirmed after removing. Reload and review all lines before trying again.');});
  const remaining=final.items.find(sourceMatches);
  const finalTarget=final.items.filter(matches).reduce((n,item)=>n+item.quantity,0);
  if(remaining || finalTarget!==previous+source.quantity || JSON.stringify(others(before))!==JSON.stringify(others(final)))throw reviewError('The cart update needs review. Reload and check all lines before trying again.');
}

document.addEventListener('click',event=>{
  const button=event.target.closest?.('[data-native-cart-upgrade]');
  if(!button)return;
  event.preventDefault();
  openEditor(button).catch(error=>{window.alert(error.message || 'Reload your cart before editing this item.');});
});

if(mapUrl){
  const loadMap=async()=>{
    let failure;
    for(let attempt=0;attempt<3;attempt++){
      try{
        const response=await fetch(mapUrl,{cache:'no-store'});
        if(!response.ok)throw Error(`Upgrade map: ${response.status}`);
        const value=await response.json();
        if(!Array.isArray(value?.products))throw Error('Upgrade map is invalid');
        return value;
      }catch(error){failure=error;if(attempt<2)await new Promise(resolve=>setTimeout(resolve,400*(attempt+1)));}
    }
    throw failure;
  };
  loadMap().then(value=>{
    manifest=value;
    refreshButtons();
    new MutationObserver(refreshButtons).observe(document.documentElement,{childList:true,subtree:true});
    if(sessionStorage.getItem('oc-native-cart-reopen')==='yes'){
      sessionStorage.removeItem('oc-native-cart-reopen');
      customElements.whenDefined('cart-drawer-component').then(()=>document.querySelector('cart-drawer-component')?.open());
    }
  }).catch(()=>{
    for(const button of document.querySelectorAll('[data-native-cart-upgrade]')){
      button.hidden=false;
      button.textContent='Reload options';
      button.addEventListener('click',()=>window.location.reload(),{once:true});
      button.closest('.native-cart-upgrade-strip')?.removeAttribute('hidden');
    }
  });
}
